async function imageUrlToBase64(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

async function svgToBase64(svgElement) {
    let svgClone = svgElement.cloneNode(true);
    let images = svgClone.querySelectorAll("image");
    for (let img of images) {
        let imageUrl = img.getAttribute("href") || img.getAttribute("xlink:href");
        if (imageUrl) {
            let base64Data = await imageUrlToBase64(imageUrl);
            img.setAttribute("href", base64Data); // Update the <image> element with Base64
        }
    } 
    let serializer = new XMLSerializer();
    let svgString = serializer.serializeToString(svgClone);
     
    let base64String = window.btoa(unescape(encodeURIComponent(svgString)));
    return "data:image/svg+xml;base64," + base64String;
}

$(document).on("click", ".fancybox-img", async function () {
    let image_element = $(this).parent(".product-image-wrapper").find("image-element");  
    let svgElement = image_element.find("svg")[0];
  
    if (svgElement) {
        if (image_element.find(".svg_to_base64_zoom").length === 0) {
            let base64SvgData = await svgToBase64(svgElement); 
            var containerWidth = parseInt(image_element.width());
            var containerHeight = parseInt(image_element.height()); 
            image_element.find("svg").addClass("hide-svg-image");
            let imgTag = `<div class="svg_to_base64_zoom tile" data-scale="2.4" data-image="${base64SvgData}" ></div>`;
            let newTile = $(imgTag);
            image_element.prepend(newTile); 
            newTile.append('<div class="photo"></div>');
            newTile.children(".photo").css({'background-image': 'url(' + base64SvgData + ')'});
        }else{
            image_element.find("svg").addClass("hide-svg-image");
            image_element.find(".tile").show();
        }
    }
});

$(document).on("change", "[name='properties[Logo]']", function() {
   $(".svg_to_base64_zoom").each(function(index) {
      $(this).remove();
   });
});

$(document).on("mouseover", ".tile", function () {
    $(this).children('.photo').css({
        'transform': 'scale(' + $(this).attr('data-scale') + ')'
    });
}).on("mouseout", ".tile", function () {
    $(this).children('.photo').css({
        'transform': 'scale(1)'
    });
    $(this).hide();
    $(this).parent("image-element").find("svg").removeClass("hide-svg-image");
}).on("mousemove", ".tile", function (e) {
    $(this).children('.photo').css({
        'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' +
            ((e.pageY - $(this).offset().top) / $(this).height()) * 100 + '%'
    });
});

